import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { gpaRoutesData1 } from "../../data/gpaRoutesData1";

const GPA1 = () => {
  return (
    <div className="min-h-screen pt-12 w-[90%] m-auto">
      <Helmet>
        <title>
          CGPA CALC
        </title>
      </Helmet>
      <h2 className="font-bold text-2xl flex justify-center">GPA 2023 Regulation [2023, 2024 Batch Follow This GPA]</h2>
      <div className="m-auto grid items-center sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 p-4 App">
        {gpaRoutesData1.map((data) => (
          <Link
            key={data.name}
            to={data.to}
            className="block transition ease-in-out duration-300 text-white hover:text-white p-6 max-w-sm m-auto w-[15rem] h-[10rem] items-center rounded-lg shadow-md bg-[#21222D] border-transparent border-4 hover:border-[#0689FF] hover:bg-[#24262f] transform hover:scale-110 hover:shadow-lg">
            <h5 className="mb-2 text-2xl font-bold ">{data.name}</h5>
            <p className="font-normal">{data.expansion}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GPA1;
